import { render, staticRenderFns } from "./PolicyAmend.vue?vue&type=template&id=77dadf8e&"
import script from "./PolicyAmend.vue?vue&type=script&lang=js&"
export * from "./PolicyAmend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports